// @ts-nocheck
import cn from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { CopyIcon } from "react-components";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";

import styles from "./styles.css";

const BlockCode = ({ children: text }) => {
    const [didCopy, setDidCopy] = useState(false);
    const handleClick = () => {
        if (didCopy) {
            return;
        }
        navigator.clipboard.writeText(text);
        setDidCopy(true);
        setTimeout(() => setDidCopy(false), 5000);
    };

    return (
        <div className={cn(styles.blockCode)}>
            <div className={cn(styles.blockCodeHeader)}>
                <button className={cn(styles.copyButton)} onClick={handleClick}>
                    <CopyIcon className={cn(styles.copyIcon)} /> {didCopy ? "Copied!" : "Copy code"}
                </button>
            </div>
            <SyntaxHighlighter
                language={"javascript"}
                style={vscDarkPlus}
                customStyle={{ margin: 0, borderRadius: "0 0 4px 4px" }}
            >
                {text}
            </SyntaxHighlighter>
        </div>
    );
};

BlockCode.propTypes = {
    children: PropTypes.node,
};

export default BlockCode;
